<template>
    <div class="row">
      <div class="col-12">
        <card :title="table1.title">
          <div class="table-responsive">
            <base-table :data="table1.data"
                        :columns="table1.columns"
                        thead-classes="text-primary">
            </base-table>
          </div>
        </card>
      </div>
    </div>
</template>
<script>
import { BaseTable } from "@/components";
import Api from '../api/api'
import { API } from '../utils/constants'

const tableColumns = ["stock", "amount", "avgOpenPrice", "created", "Value", "P/L($)", "P/L(%)"];

export default {
  components: {
    BaseTable
  },
  data() {
    return {
      table1: {
        title: "Portfolio",
        columns: [...tableColumns],
        data: []
      }
    };
  },
  mounted () {
    Api.get(API.ASSETS).then(res => {
        var arr1 = [];
        res.data.forEach(element => {
          var date = new Date(element.createdAt);
          var dt = new Intl.DateTimeFormat(['ban', 'id']).format(date)
          var da = {
            "stock": element.stock.toUpperCase(),
            "amount":  element.amount,
            "avgopenprice": element.avgOpenPrice,
            "created": dt,
          }
          console.log(da);
          arr1.push(da);
        });

        console.log(res.data);

        this.table1.data=arr1

    })
  }
};
</script>
<style>
</style>
